import { Immutable } from "immer";
import React from "react";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.FooterIFrameDocumentTemplate>,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            showHeader={false}
            wrapMain={false}
            bareChrome={true}
        >
            <script
                src={`${staticBase}dist2/iframe-resizer/iframeResizer.contentWindow.js`}
            />
        </PageSkeleton>
    );
};
